import React, { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import * as actions from "../../store/actions/actions"
import ToggleFullscreen from "../Common/ToggleFullscreen"
import HeaderRun from "./Header.run"
import { withNamespaces } from "react-i18next"
import Swal from "sweetalert2"
import { UserDatabaseConnector } from "../../dataconnector/usersDatabaseConnector"
import { syncManager } from "../../dataconnector/syncManager"
import TaskNotificationDropdown from "./TaskNotificationDropdown"
import NoteNotificationDropdown from "./NoteNotificationDropdown"
import TicketNotificationBadge from "./TicketNotificationBadge"
import TranslationProposalsBadge from "./TranslationProposalsBadge"
import GlobalBanner from "./GlobalBanner"
import i18n from "i18next";
import { Link, withRouter } from "react-router-dom"
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Input, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap"
import FlagIcon from "../CustomComponents/FlagIcon"
import LegacyGlobalNavigationSearch from "./LegacyGlobalNavigationSearch"

// Langues disponibles (uniquement celles avec traductions)
import { WEB_LANGUAGES as LANGUAGES } from "../../webLanguages";
import { ALL_PARKS_PATHS, filterParks, loadParkSwitcher, switchToPark } from "../../navigation-v2/app/parkSwitcher";
import { initAuth } from "../../tools/conf";

let sync = new syncManager()

const headerUserConnector = new UserDatabaseConnector()

class Header extends Component {
  state = {
    languageDropdownOpen: false,
    // Choix du parc (droits multi-parcs, étape 4) : même chargement, même
    // recherche et même bascule que l'interface Nouvelle ; null = rien à proposer.
    parkSwitcher: null,
    parkModalOpen: false,
    parkQuery: "",
    parkSwitchPending: false,
    parkSwitchFailed: false,
  }

  componentDidMount() {
    HeaderRun()
    this.loadParkSwitcher()
  }

  componentWillUnmount() {
    this.unmounted = true
  }

  loadParkSwitcher = async () => {
    try {
      const uid = initAuth()?.currentUser?.uid
      const parkSwitcher = await loadParkSwitcher({ userConnector: headerUserConnector, uid })
      if (!this.unmounted) this.setState({ parkSwitcher })
    } catch (_error) {
      // Sans choix de parc, l'en-tête reste celui d'avant.
    }
  }

  openParkModal = () => {
    this.setState({ parkModalOpen: true, parkQuery: "", parkSwitchFailed: false })
  }

  closeParkModal = () => {
    if (!this.state.parkSwitchPending) this.setState({ parkModalOpen: false })
  }

  // Fenêtre de choix du parc : recherche, parcs de la personne (le parc actuel
  // marqué par un liseré), et pour le staff le lien vers tous les parcs.
  renderParkModal = () => {
    const { t } = this.props
    const { parkSwitcher, parkModalOpen, parkQuery, parkSwitchPending, parkSwitchFailed } = this.state
    const parks = filterParks(parkSwitcher.parks, parkQuery)
    return (
      <Modal isOpen={parkModalOpen} toggle={this.closeParkModal} centered autoFocus={false}>
        <ModalHeader
          toggle={this.closeParkModal}
          close={
            <button className="close" onClick={this.closeParkModal} aria-label={t("common.close")}>
              <span aria-hidden="true" style={{ fontSize: "1.5rem" }}>&times;</span>
            </button>
          }
          style={{ backgroundColor: "#f8f9fc", borderBottom: "1px solid #e3e6f0" }}
        >
          <span style={{ color: "#5a5c69", fontWeight: 600 }}>
            <i className="fas fa-exchange-alt mr-2"></i>
            {t("navigationV2.header.switchPark")}
          </span>
        </ModalHeader>
        <ModalBody style={{ padding: "1.5rem" }}>
          <p className="text-muted mb-3" style={{ fontSize: "13px" }}>{t("navigationV2.header.switchParkDescription")}</p>
          <Input
            type="search"
            autoFocus
            value={parkQuery}
            onChange={(event) => this.setState({ parkQuery: event.target.value })}
            placeholder={t("navigationV2.header.searchParkPlaceholder")}
            aria-label={t("navigationV2.header.searchPark")}
            style={{ borderRadius: "8px", border: "1px solid #d1d3e2" }}
          />
          {parkSwitchFailed ? (
            <div className="text-danger mt-2" role="alert" style={{ fontSize: "13px" }}>
              {t("navigationV2.header.switchParkFailed")}
            </div>
          ) : null}
          {parks.length ? (
            <div className="list-group mt-3" style={{ maxHeight: "360px", overflowY: "auto" }}>
              {parks.map((park) => {
                const current = park.zooId === parkSwitcher.currentZooId
                return (
                  <button
                    key={park.zooId}
                    type="button"
                    className="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
                    aria-current={current ? "true" : undefined}
                    disabled={current || parkSwitchPending}
                    onClick={() => this.handleParkSwitch(park)}
                    style={{ borderLeft: current ? "4px solid #4e73df" : undefined, color: "#5a5c69" }}
                  >
                    <span style={{ fontWeight: 600 }}>{park.zooName}</span>
                    {current ? (
                      <span className="small text-muted">
                        <em className="fas fa-check mr-1"></em>
                        {t("navigationV2.header.currentPark")}
                      </span>
                    ) : null}
                  </button>
                )
              })}
            </div>
          ) : (
            <p className="text-muted mt-3 mb-0" role="status" style={{ fontSize: "13px" }}>
              {/* Staff sans registre (temps 1) : aucun parc listé, l'accès passe par « Tous les parcs ». */}
              {t(!String(parkQuery || "").trim() && parkSwitcher.allParks
                ? "navigationV2.header.noListedParks"
                : "navigationV2.header.noParkMatches")}
            </p>
          )}
        </ModalBody>
        {parkSwitcher.allParks ? (
          <ModalFooter>
            <Link className="btn btn-outline-secondary" to={ALL_PARKS_PATHS.v1} onClick={() => this.setState({ parkModalOpen: false })}>
              {t("navigationV2.header.allParks")}
            </Link>
          </ModalFooter>
        ) : null}
      </Modal>
    )
  }

  handleParkSwitch = async (park) => {
    this.setState({ parkSwitchPending: true, parkSwitchFailed: false })
    try {
      const uid = initAuth()?.currentUser?.uid
      const result = await switchToPark({ userConnector: headerUserConnector, uid, park })
      if (!result?.switched && !this.unmounted) this.setState({ parkSwitchPending: false, parkSwitchFailed: true })
    } catch (_error) {
      if (!this.unmounted) this.setState({ parkSwitchPending: false, parkSwitchFailed: true })
    }
  }

  toggleLanguageDropdown = () => {
    this.setState((prevState) => ({
      languageDropdownOpen: !prevState.languageDropdownOpen,
    }))
  }

  dismissSearch = () => {
    const searchForm = document.querySelector("form.navbar-form")
    searchForm?.classList.remove("open")
    searchForm?.querySelector('input[type="search"], input[type="text"]')?.blur()
  }

  getCurrentLanguage = () => {
    const currentLang = (i18n.language || "en").slice(0, 2)
    // Afficher EN pour une langue non prise en charge.
    return LANGUAGES.find((lang) => lang.code === currentLang) || LANGUAGES[1] // EN
  }

  handleLanguageChange = async (langCode) => {
    try {
      // Changer la langue dans i18n
      await i18n.changeLanguage(langCode)

      // Sauvegarder la préférence web locale
      localStorage.setItem("webLanguagePreference", langCode)

      // Mettre à jour aussi userData pour la cohérence locale
      const userDataStr = localStorage.getItem("userData")
      if (userDataStr) {
        const userData = JSON.parse(userDataStr)
        userData.webLanguagePreference = langCode
        localStorage.setItem("userData", JSON.stringify(userData))
      }

      // Persister en Firestore (survit au logout, changement de zoo, autre device)
      const uConnect = new UserDatabaseConnector()
      uConnect._updateWebLanguagePreference(langCode).catch((err) =>
        console.error("Error persisting web language preference:", err)
      )
    } catch (error) {
      console.error("Error changing language:", error)
    }
  }

  toggleUserblock = (e) => {
    e.preventDefault()
    this.props.actions.toggleSetting("showUserBlock")
  }

  toggleOffsidebar = (e) => {
    e.preventDefault()
    this.props.actions.toggleSetting("offsidebarOpen")
  }

  toggleCollapsed = (e) => {
    e.preventDefault()
    this.props.actions.toggleSetting("isCollapsed")
    this.resize()
  }

  toggleAside = (e) => {
    e.preventDefault()
    this.props.actions.toggleSetting("asideToggled")
  }

  handleDisconnect = async (e) => {
    const { t } = this.props
    Swal.fire({
      title: t("common.DISCONNECT"),
      showCancelButton: true,
      confirmButtonText: `Oui`,
      cancelButtonText: t("common.CANCEL"), // Add i18n for cancel button
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        Swal.fire({
          title: t("common.loggingOut"),
          html: t("common.loggingOutText"),
          allowOutsideClick: false,
          allowEscapeKey: false,
          showCancelButton: false,
          showConfirmButton: false,
          willOpen: () => {
            Swal.showLoading()
          },
        })
        let uConnect = new UserDatabaseConnector()
        await uConnect._disconnectUser()
        await uConnect._RemoveRememberMe()
        window.location = "login"
      }
    })
  }

  handleSync = async () => {
    const { t } = this.props
    Swal.fire({
      icon: "info",
      title: t("common.pleaseWait"),
      html: t("common.massSyncInProgress"),
      allowOutsideClick: false,
      showCancelButton: false,
      showConfirmButton: false,
      willOpen: () => {
        Swal.showLoading()
      },
    })
    let res = await sync._handleMassSync()

    console.log(res)
    Swal.fire({
      title: t("common.massSyncCompleted"),
    })
  }

  resize() {
    // all IE friendly dispatchEvent
    var evt = document.createEvent("UIEvents")
    evt.initUIEvent("resize", true, false, window, 0)
    window.dispatchEvent(evt)
    // modern dispatchEvent way
    // window.dispatchEvent(new Event('resize'));
  }

  render() {
    return (
      <header className='topnavbar-wrapper'>
        {/* Global Banner */}
        <GlobalBanner />
        {/* START Top Navbar */}
        <nav className='navbar topnavbar'>
          {/* START navbar header */}
          <div className='navbar-header'>
            <a className='navbar-brand' href='#/'>
              <div className='brand-logo'>
                <img className='img-fluid' style={{ maxWidth: 200 }} src='img/WELFARE-MANAGER_LOGO_HEADER.png' alt='App Logo' />
              </div>
              <div className='brand-logo-collapsed'>
                <img className='img-fluid' style={{ width: 40 }} src='logo_akongo_white.png' alt='App Logo' />
              </div>
            </a>
          </div>
          {/* END navbar header */}

          {/* START Left navbar */}
          <ul className='navbar-nav legacy-header-left-actions flex-row'>
            <li className='nav-item d-xl-none'>
              {/* Button used to collapse the left sidebar. Only visible on tablet and desktops */}
              <button type='button' className='nav-link d-none d-md-block d-lg-block d-xl-block border-0 bg-transparent' onClick={this.toggleCollapsed}>
                <em className='fas fa-bars'></em>
              </button>
              {/* Button to show/hide the sidebar on mobile. Visible on mobile only. */}
              <button type='button' className='nav-link sidebar-toggle d-md-none border-0 bg-transparent' onClick={this.toggleAside}>
                <em className='fas fa-bars'></em>
              </button>
            </li>
            {/* START User avatar toggle */}
            <li className='nav-item d-none d-md-block'>
              <button type='button' className='nav-link border-0 bg-transparent' onClick={this.toggleUserblock}>
                <em className='icon-user'></em>
              </button>
            </li>
            {/* END User avatar toggle */}

            <li className='nav-item'>
              <button
                type='button'
                className='nav-link border-0 bg-transparent'
                data-search-open=''
                aria-label={this.props.t("navigationV2.search.label")}
                title={this.props.t("navigationV2.search.label")}
              >
                <em className='icon-magnifier'></em>
              </button>
            </li>

            <li className='nav-item d-none d-md-block'>
              <ToggleFullscreen className='nav-link' />
            </li>
            <li className='nav-item'>
              <button type='button' className='nav-link border-0 bg-transparent' onClick={this.toggleOffsidebar}>
                <em className='icon-notebook'></em>
              </button>
            </li>
            <li className='nav-item d-none d-md-block'>
              <button type='button' className='nav-link border-0 bg-transparent' onClick={this.handleDisconnect}>
                <em className={"fas fa-sign-out-alt"}></em>
              </button>
            </li>
          </ul>
          {/* END Left navbar */}

          {/* Persistent V1 universal search */}
          <div className='legacy-header-search-slot d-none d-xl-flex'>
            <LegacyGlobalNavigationSearch
              history={this.props.history}
              i18n={this.props.i18n}
              location={this.props.location}
              t={this.props.t}
              zoo={this.props.zoo}
            />
          </div>

          {/* START Right Navbar */}
          <ul className='navbar-nav legacy-header-right-actions flex-row' style={{ alignItems: "center" }}>
            {/* Zoo Name, et choix du parc quand il y a un choix (masqué en mode démo) */}
            <li className='nav-item d-none d-md-block'>
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "row", marginRight: 15 }}>
                <div style={{ fontWeight: "bold", color: "white", fontSize: 18 }}>{this.props.zoo.anonymousMode ? this.props.t("common.demoMode") : this.props.zoo.zooName}</div>
                {this.state.parkSwitcher && !this.props.zoo.anonymousMode ? (
                  <>
                    <a
                      className="nav-link"
                      role="button"
                      tabIndex={0}
                      aria-haspopup="dialog"
                      aria-label={this.props.t("navigationV2.header.switchPark")}
                      title={this.props.t("navigationV2.header.switchPark")}
                      onClick={this.openParkModal}
                      onKeyDown={(event) => {
                        if (event.key === "Enter" || event.key === " ") {
                          event.preventDefault()
                          this.openParkModal()
                        }
                      }}
                      style={{ cursor: "pointer", padding: "0.25rem 0.5rem", marginLeft: 4 }}
                    >
                      <em className="fa fa-angle-down" style={{ color: "white", fontSize: "1rem" }}></em>
                    </a>
                    {this.renderParkModal()}
                  </>
                ) : null}
              </div>
            </li>

            {/* Ticket Notifications (Akongo admin only) */}
            {(() => {
              try {
                const ud = JSON.parse(localStorage.getItem("userData") || "{}");
                if (ud.akongoStaff === true || ud.akongoRank === "board") {
                  return (
                    <>
                      {/* Raccourci de saisie du temps. Volontairement sans
                          pastille « rien loggé aujourd'hui » : le module est
                          conçu pour ne mettre aucune pression sur celui qui logue. */}
                      <li className='nav-item' style={{ marginRight: 5 }}>
                        <Link
                          to='/TimeTrackingView'
                          className='nav-link'
                          style={{ padding: "0.5rem 1rem" }}
                          title={this.props.t("timeTracking.title")}
                        >
                          <em className='fas fa-stopwatch' style={{ fontSize: "1.3rem", color: "white" }}></em>
                        </Link>
                      </li>
                      <li className='nav-item' style={{ marginRight: 5 }}>
                        <TicketNotificationBadge />
                      </li>
                      <li className='nav-item' style={{ marginRight: 5 }}>
                        <TranslationProposalsBadge />
                      </li>
                    </>
                  );
                }
              } catch (e) {}
              return null;
            })()}

            {/* Note Notifications (in-app channel only) — à gauche des tâches */}
            <li className='nav-item' style={{ marginRight: 15 }}>
              <NoteNotificationDropdown />
            </li>

            {/* Task Notifications */}
            <li className='nav-item' style={{ marginRight: 15 }}>
              <TaskNotificationDropdown />
            </li>


            {/* Language Selector */}
            <li className='nav-item'>
              <Dropdown isOpen={this.state.languageDropdownOpen} toggle={this.toggleLanguageDropdown}>
                <DropdownToggle
                  tag="a"
                  className="nav-link"
                  style={{
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    padding: "0.5rem 0.75rem",
                    backgroundColor: "rgba(255,255,255,0.1)",
                    borderRadius: "6px",
                    transition: "background-color 0.2s",
                  }}
                >
                  <FlagIcon code={this.getCurrentLanguage().code} size={22} style={{ marginRight: 6 }} />
                  <span style={{ color: "white", fontWeight: "500", fontSize: "0.9rem" }}>
                    {this.getCurrentLanguage().label}
                  </span>
                  <em className="fa fa-angle-down" style={{ marginLeft: "6px", color: "white", fontSize: "0.8rem" }}></em>
                </DropdownToggle>
                <DropdownMenu right style={{ minWidth: "160px", borderRadius: "8px", boxShadow: "0 4px 12px rgba(0,0,0,0.15)" }}>
                  {LANGUAGES.map((lang) => (
                    <DropdownItem
                      key={lang.code}
                      onClick={() => this.handleLanguageChange(lang.code)}
                      active={this.getCurrentLanguage().code === lang.code}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        padding: "10px 15px",
                        cursor: "pointer",
                      }}
                    >
                      <FlagIcon code={lang.code} size={22} style={{ marginRight: 10 }} />
                      <span>{lang.name}</span>
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </Dropdown>
            </li>

            {/* END Alert menu */}
            {/* START Offsidebar button */}

            {/* END Offsidebar menu */}
          </ul>
          {/* END Right Navbar */}

          {/* START Search form */}
          <form
            className='navbar-form legacy-universal-search-form d-xl-none'
            role='search'
            onSubmit={(event) => event.preventDefault()}
          >
            <div
              className='legacy-universal-search-shell'
              onClick={(event) => event.stopPropagation()}
            >
              <LegacyGlobalNavigationSearch
                history={this.props.history}
                i18n={this.props.i18n}
                location={this.props.location}
                onNavigateComplete={this.dismissSearch}
                t={this.props.t}
                zoo={this.props.zoo}
              />
              <button
                type='button'
                className='fa fa-times navbar-form-close border-0 bg-transparent'
                data-search-dismiss=''
                aria-label={this.props.t("common.CLOSE")}
                title={this.props.t("common.CLOSE")}
              />
            </div>
          </form>
          {/* END Search form */}
        </nav>
        {/* END Top Navbar */}
      </header>
    )
  }
}

Header.propTypes = {
  actions: PropTypes.object,
  settings: PropTypes.object,
  zoo: PropTypes.object,
  history: PropTypes.object,
  i18n: PropTypes.object,
  location: PropTypes.object,
  t: PropTypes.func,
}

const mapStateToProps = (state) => ({ settings: state.settings, zoo: state.zoo })
const mapDispatchToProps = (dispatch) => ({ actions: bindActionCreators(actions, dispatch) })

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(Header)))
